import ReactDOM from 'react-dom'
import App from './Components/App'
import './index.css'

ReactDOM.render(
    <App />,
    document.getElementById('root')
);